import { CONFIG } from './environment_variables';

export const INITIALIZE_APP_REQUEST = 'VARICON/@src/app/INITIALIZE_APP_REQUEST';
export const INITIALIZE_APP_SUCCESS = 'VARICON/@src/app/INITIALIZE_APP_SUCCESS';
export const INITIALIZE_APP_FAILURE = 'VARICON/@src/app/INITIALIZE_APP_FAILURE';

export const LOAD_INITIAL_REQUEST = 'VARICON/@src/app/LOAD_INITIAL_REQUEST';
export const LOAD_INITIAL_SUCCESS = 'VARICON/@src/app/LOAD_INITIAL_SUCCESS';
export const LOAD_INITIAL_FAILURE = 'VARICON/@src/app/LOAD_INITIAL_FAILURE';

const apiUrl = import.meta.env.VITE_APP_API_URL;

export const API_URL = `${apiUrl}/api/v1`;

export const API_DJANGO = {
  baseURL: '/api/v1',
  headers: {
    'Content-Type': 'application/json',
    // 'X-CSRFToken': getCookie('csrftoken'),
  },
};

export const API = {
  name: 'api',
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
};

export const WS_API_URL = CONFIG.API_URL.replace('https', 'wss');

export const LOGIN_API = '/v1.1/token/';

export const GET_ALLOWANCE_SETTING =
  '/v1.1/allowance/setting_organisation_get/';
export const POST_ALLOWANCE_SETTING =
  '/v1.1/allowance/setting_organisation_post/';
export const USER_FROM_TOKEN_API = '/user/user_data/';
export const DEFAULT_TAX_API = '/tax-setting/default_tax/';
export const PURCHASE_ORDERS_API = '/purchase-order/';
export const PURCHASE_ORDERS_SUPPLIERS_API = '/purchase-order/suppliers/';
export const PURCHASE_ORDERS_PROJECTS_API = '/purchase-order/projects/';
export const PURCHASE_ORDERS_AUTOGENERATED_PO_NUMBER_API =
  '/purchase-order/autogenerated_po/';
export const PURCHASE_ORDERS_TAX_LIST_API = '/purchase-order/tax_list/';
export const PURCHASE_ORDERS_RESOURCE_CODES_API =
  '/purchase-order/resource_codes/';
export const PURCHASE_ORDERS_RESOURCE_CODES_RECENT_API =
  '/purchase-order/get_recent_and_other_resources/';
export const PURCHASE_ORDERS_PROJECT_ADDRESS_API =
  '/purchase-order/project_address/';
export const PURCHASE_ORDERS_WORKFLOW_LIST_API = '/purchase-order-workflow/';
export const PURCHASE_ORDERS_WORKFLOW_DETAIL_API =
  '/purchase-order-workflow/:id/';
export const PURCHASE_ORDERS_COUNTRIES_API = '/purchase-order/countries/';
export const PURCHASE_ORDERS_STATES_API = '/purchase-order/states/';
export const PURCHASE_ORDERS_POSSIBLE_APPROVERS_API =
  '/purchase-order/possible_approvers/';
export const PURCHASE_ORDERS_USERS_TO_NOMINATE_API =
  '/purchase-order/search_users_for_nominate/';
export const PURCHASE_ORDERS_RESOURCE_CODE_DETAIL_API =
  '/purchase-order/resource_code_data/';
export const PURCHASE_ORDERS_DETAIL_API = '/purchase-order/:id/';
export const PURCHASE_ORDERS_DETAIL_WORKFLOW_STEPS_API =
  '/purchase-order/:id/workflow_steps/';
export const PURCHASE_ORDERS_DETAIL_ADD_APPROVER_API =
  '/purchase-order/:id/add_approver/';
export const PURCHASE_ORDERS_DETAIL_DELETE_APPROVER_API =
  '/purchase-order/:id/delete_approver/';
export const PURCHASE_ORDERS_COMMENT_API = '/purchase-order-comment/';
export const PURCHASE_ORDERS_COMMENT_ID_API = '/purchase-order-comment/:id/';
export const PURCHASE_ORDERS_CANCEL_PO_API = '/purchase-order/:id/cancel_po/';
export const PURCHASE_ORDERS_NEXT_STEP_API =
  '/purchase-order/:id/move_step_po/';
export const PURCHASE_ORDERS_REJECT_API = '/purchase-order/:id/reject_po/';
export const PURCHASE_ORDERS_REVOKE_API = '/purchase-order/:id/revoke_po/';
export const PURCHASE_ORDERS_DOWNLOAD_PDF_API =
  '/purchase-order/:id/purchase_order_pdf/';
export const PURCHASE_ORDERS_DOWNLOAD_WORD_API =
  '/purchase-order/:id/purchase_order_word/';
export const PURCHASE_ORDERS_MAIN_WORKFLOW_STEPS_API =
  '/purchase-order/main_workflow_steps/';
export const PURCHASE_ORDERS_UPDATE_DELIVERY_STATUS =
  '/purchase-order/:id/update_delivery_status/';
export const PURCHASE_ORDERS_SUBTASKS_API = '/purchase-order/sub_tasks/';
export const PURCHASE_ORDERS_COST_CENTER = '/purchase-order/cost_centers/';
export const PURCHASE_ORDERS_IVREF_API = '/purchase-order-invoice-ref-no/';
export const PURCHASE_ORDERS_IVREF_ID_API =
  '/purchase-order-invoice-ref-no/:id/';
export const PURCHASE_ORDERS_CHANGE_DOCKET_STATUS_API =
  '/purchase-order/change_docket_status/';
export const PURCHASE_ORDERS_WORKFLOW_ROLES = `/purchase-order-workflow/roles/`;

export const COST_CENTER = '/costcenter/';

export const RESOURCE_TAG_API = '/v1.1/resource-type/';

// settings equipments
export const SETTINGS_EQUIPMENTS_API = '/v1.1/equipment/';

// employees
export const EMPLOYEES_API = '/employee/list_employee/';
export const EMPLOYEE_API = '/employee/';
export const EMPLOYEE_RESOURCE_CODES_API =
  '/employee/get_default_resource_codes/';
export const EMPLOYEE_DETAIL_API = '/employee/:id/';
export const SEND_PIN_RESET_LINK_API = '/employee/send_pin_reset_link/';
export const COMPANY_NAME_API = 'v1.1/equipment_supplier/';
// timesheet
export const TIMESHEET_EXPORT_API = 'timesheet/export_timesheet/';
export const TIMESHEET_EXPORT_EMP_HERO_API =
  'timesheet/export_employment_hero/';

export const TIMESHEET_EXPORT_QUICKBOOKS_API = 'timesheet/export_quickbooks/';

export const TIMESHEET_DAYWORK_EXPORT_API = 'timesheet/export_dayworkdockets/';
export const TIMESHEET_TEMPLATE_DOWNLOAD_API =
  'timesheet/export_timesheet_template/';
// supplier
export const SUPPLIER_TEMPLATE_DOWNLOAD_API =
  'mobile/supplier/supplier_sample_template/';

// v1.1

// Daily Cost Tracking
export const GET_DCT_DATA = '/dct/list_aggregate_dcts/';
export const DELETE_DCT_DATA = '/dct/delete_multiple_dcts/';
export const TIMESHEET_DATA = '/dct/list_sub_dcts/';
export const DOCKET_DCTS = '/dct/list_docket_dcts/';
export const TIMESHEET_DCTS = '/dct/list_timesheet_dcts/';
export const SUBCONTRACT_DCTS = '/dct/list_subcontract_claim_dcts/';
export const BILLS_DCTS = '/dct/list_bills_dcts/';
export const CREDIT_NOTE_DCTS = '/dct/list_credit_note_dcts/';
export const EQUIPMENT_DCTS = '/dct/list_equipment_dcts/';
export const SITEDIARY_DCTS = '/dct/list_sitediary_dcts/';
export const EQUIPMENT_ATTACHMENT_DCTS = '/dct/list_equipment_attachment_dcts/';
export const SITE_DIARY_EQUIPMENT_ATTACHMENT_DCTS =
  '/dct/list_site_diary_equipment_attachment_dcts/';
export const TASKS_DATA = '/dct/get_tasks/';
// export const RESOURCE_DATA = '/dct/get_resources/';
export const RESOURCE_DATA = '/v1.1/resources/dropdown/get_resources/';
export const SUPPLIERS_OPTION =
  '/v1.1/resources/dropdown/get_resource_suppliers/';
export const COST_CENTER_DATA = '/dct/get_cost_centers/';
export const ADD_DCT = '/dct/create_manual_dct/';
export const UPDATE_DCT = '/dct/1759/update_manual_dct/';
export const APPROVE_DCTS = '/dct/approve_unapprove_multiple_dcts/';
export const ADD_MULTIPLE_DCTS = '/v1.2/daily-costs/';
export const ADD_MULTIPLE_ATTACHMENT = '/attachment/multiple_create/';
export const ADD_ATTACHMENT = '/attachment/';
export const ADD_ATTACHMENT_V2 = 'attachment/save_attachment/';
export const ADD_NOTES = '/dct/save_attachments_notes/';
export const GET_NOTES = '/dct/get_attachments_notes/';
export const EXPORT_DCT = '/dct/export_dcts/';
export const EXPORT_EQUIPMENT_DCT = '/dct/export_equipment/';

export const GET_EQUIPMENT_TYPE = '/v1.1/equipment_type/get_list/';

// copy dct
export const GET_COPY_DCT_DATA = '/dct/get_approved_manual_dcts/';

// untracked resources dct
export const UNTRACKED_RESOURCES_DCTS = '/dct/list_untracked_resources/';
export const COST_SUMMARY_DCTS = '/dct/get_cost_summary/';

export const MIDSHIP_EXTRACTION_KNOWLEDGE_BASE_URL =
  'https://varicon.help.usepylon.com/articles/6140749310-bill-of-quantity-extracting-using-varicon-estimation-sheet-formatter';

export const MULTI_TEMPLATE_KNOWLEDGE_BASE_URL =
  'https://varicon.help.usepylon.com/articles/8732902791-blank-kb-article';

export const UPDATE_MESSAGE_FOR_ESIMATION_SHEETS =
  'We have recently updated the import template. Kindly use the new spreadsheet template by clicking on the "Download Sample Spreadsheet" button above.';

export const USER_JOTFORM = '/v1.1/user-jotform/';

export const USER_JOTFORM_LINK =
  'https://docs.google.com/forms/d/e/1FAIpQLSciFi2U9qXz0a87nv5gVchdQA-W2tDYzt0E8V0PKA2iHNVtzw/viewform';

export const VARICON_TIMESHEET_APP_ON_GOOGLE_PLAY_URL =
  'https://play.google.com/store/apps/details?id=com.varicon.empvaricon&hl=en';
export const VARICON_TIMESHEET_APP_ON_APPLE_STORE_URL =
  'https://apps.apple.com/us/app/varicon-timesheet/id6739243092';
